import React from 'react';

const ClipboardInput = ({ onSubmit, currentText, setCurrentText }) => {
    const MAX_CHARACTERS = 5000; // 5000 character limit

    const handleSave = () => {
        if (currentText.trim().length === 0) {
            alert('Please enter some text before saving');
            return;
        }
        onSubmit(currentText);
    };

    const handleClear = () => {
        setCurrentText('');
    };

    const handleTextChange = (e) => {
        const text = e.target.value;
        if (text.length <= MAX_CHARACTERS) {
            setCurrentText(text);
        }
    };

    const charCount = currentText.length;
    const isNearLimit = charCount > MAX_CHARACTERS * 0.8; // Warn at 80%
    const isAtLimit = charCount === MAX_CHARACTERS;

    return (
        <div className="input-section">
            <div className="input-header">
                <label className="input-label">Input Text</label>
                <span className={`char-count ${isNearLimit ? 'warning' : ''} ${isAtLimit ? 'limit-reached' : ''}`}>
                    {charCount} / {MAX_CHARACTERS}
                </span>
            </div>
            <textarea
                className="input-field"
                value={currentText}
                onChange={handleTextChange}
                placeholder="Input Text Here"
                maxLength={MAX_CHARACTERS}
            />
            <div className="button-group">
                <button 
                    className="btn" 
                    onClick={handleSave}
                    disabled={currentText.trim().length === 0}
                >
                    Save
                </button>
                <button className="btn btn-secondary" onClick={handleClear}>
                    Clear
                </button>
            </div>
        </div>
    );
};

export default ClipboardInput;